import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiDollarSign,FiTrendingUp,FiCheck}=FiIcons;

const ValueSection=()=> {
  const valueItems=[
    {item: "Ticket: Bazi Love & Relationships (2 วัน)",value: "12,500 บาท"},
    {item: "Bonus 1: VDO Bazi Startup Course: Bazi Foundations",value: "8,900 บาท"},
    {item: "Bonus 2: Toxic People Radar",value: "3,500 บาท"},
    {item: "Bonus 3: Team Synergy Chart",value: "5,900 บาท"},
    {item: "Bonus 4: VDO Case Study",value: "4,500 บาท"},
    {item: "อาหารกลางวัน + เบรคโรงแรม (2 วัน)",value: "2,000 บาท"}
  ];

  const totalValue=37300;
  const specialPrice=9995;
  const savings=totalValue - specialPrice;
  const discountPercent=Math.round((savings / totalValue) * 100);

  return (
    <section className="py-20 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-orange-900/10 to-transparent"></div>
      
      {/* Background Animation */}
      <div className="absolute top-20 right-10 w-32 h-32 bg-orange-500/10 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-20 left-10 w-40 h-40 bg-red-500/10 rounded-full blur-xl animate-pulse delay-1000"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.div
          initial={{y: 30,opacity: 0}}
          whileInView={{y: 0,opacity: 1}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text text-transparent">
              ตีแผ่ความคุ้มค่า
            </span>
          </h2>
          <h3 className="text-2xl md:text-3xl font-semibold text-white mb-8">
            มาดูกันชัดๆ ว่าคุณกำลังได้รับ <span className="text-orange-400">"มูลค่า"</span> เท่าไหร่?
          </h3>
          <p className="text-lg text-gray-300">
            (เทียบกับสิ่งที่คุณจ่ายจริง)
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          {/* Value Breakdown Table */}
          <motion.div
            initial={{y: 50,opacity: 0}}
            whileInView={{y: 0,opacity: 1}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="bg-slate-800/50 backdrop-blur-sm border border-orange-500/30 rounded-2xl overflow-hidden mb-12"
          >
            <div className="bg-gradient-to-r from-orange-500/20 to-red-500/20 p-6 border-b border-orange-500/30">
              <h4 className="text-2xl font-bold text-white text-center">
                รายการ (What You Get) vs มูลค่าประเมิน (Value)
              </h4>
            </div>
            
            <div className="p-6">
              <div className="space-y-4">
                {valueItems.map((item,index)=> (
                  <motion.div
                    key={index}
                    initial={{x: -20,opacity: 0}}
                    whileInView={{x: 0,opacity: 1}}
                    transition={{duration: 0.6,delay: index * 0.1}}
                    viewport={{once: true}}
                    className="flex justify-between items-center py-3 px-4 bg-slate-700/30 rounded-xl border border-slate-600/50 hover:border-orange-500/50 transition-all duration-300"
                  >
                    <div className="flex items-center">
                      <SafeIcon icon={FiCheck} className="text-green-400 mr-3" />
                      <span className="text-gray-300">{item.item}</span>
                    </div>
                    <span className="text-orange-400 font-bold">{item.value}</span>
                  </motion.div>
                ))}
              </div>

              {/* Total Value */}
              <motion.div
                initial={{y: 20,opacity: 0}}
                whileInView={{y: 0,opacity: 1}}
                transition={{duration: 0.8,delay: 0.8}}
                viewport={{once: true}}
                className="mt-6 pt-6 border-t border-orange-500/30"
              >
                <div className="flex justify-between items-center py-4 px-6 bg-gradient-to-r from-orange-500/20 to-red-500/20 rounded-xl border border-orange-500/50">
                  <span className="text-xl font-bold text-white">รวมมูลค่าทั้งหมด (Total Value)</span>
                  <span className="text-2xl font-bold text-orange-400">~~{totalValue.toLocaleString()} บาท~~</span>
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* Price Comparison */}
          <motion.div
            initial={{scale: 0.9,opacity: 0}}
            whileInView={{scale: 1,opacity: 1}}
            transition={{duration: 0.8,delay: 0.4}}
            viewport={{once: true}}
            className="text-center"
          >
            <div className="bg-gradient-to-br from-red-500/20 to-pink-500/20 backdrop-blur-sm border-2 border-red-500/30 rounded-3xl p-8 relative overflow-hidden">
              {/* Background Effects */}
              <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 via-pink-500/10 to-orange-500/10"></div>
              <div className="absolute top-0 left-0 w-32 h-32 bg-red-500/20 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 right-0 w-40 h-40 bg-pink-500/20 rounded-full blur-3xl"></div>
              
              <div className="relative z-10">
                <h4 className="text-3xl font-bold text-white mb-6">
                  คุณไม่ต้องจ่าย <span className="text-red-400 line-through text-2xl">3 หมื่น</span>...
                </h4>
                <h5 className="text-2xl font-bold text-white mb-6">
                  คุณไม่ต้องจ่ายราคาเต็ม <span className="text-red-400 line-through text-xl">12,500</span>...
                </h5>
                
                <div className="bg-slate-800/60 border-2 border-pink-500/50 rounded-2xl p-8 mb-6 relative">
                  {/* Glow Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-pink-500/20 to-purple-500/20 rounded-2xl animate-pulse"></div>
                  
                  <div className="relative z-10">
                    <h6 className="text-xl font-semibold text-white mb-6">ข้อเสนอพิเศษ (สำหรับคนที่เห็นหน้านี้เท่านั้น):</h6>
                    <div className="text-5xl md:text-6xl font-bold text-pink-400 mb-4">
                      จ่ายเพียง {specialPrice.toLocaleString()} บาท
                    </div>
                    <p className="text-lg text-green-400 font-semibold">
                      ประหยัดทันที {savings.toLocaleString()} บาท หรือลดลงกว่า {discountPercent}% จากมูลค่าจริง
                    </p>
                  </div>
                </div>

                {/* PROMINENT Investment Statement */}
                <div className="bg-gradient-to-br from-yellow-500/30 via-orange-500/30 to-red-500/30 border-3 border-yellow-500/50 rounded-3xl p-8 mb-6 relative overflow-hidden">
                  {/* Animated Background */}
                  <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/20 via-orange-500/20 to-red-500/20 animate-gradient"></div>
                  
                  <div className="relative z-10">
                    <div className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
                      🚨 การลงทุนครั้งนี้... 🚨
                    </div>
                    <div className="text-2xl md:text-3xl font-bold text-yellow-300 mb-4 leading-tight">
                      ถูกกว่าค่า <span className="text-red-400">"เลิกจ้าง"</span>
                    </div>
                    <div className="text-2xl md:text-3xl font-bold text-orange-300 leading-tight">
                      หรือค่า <span className="text-red-400">"หย่าร้าง"</span>
                    </div>
                    <div className="text-4xl md:text-5xl font-bold text-white mt-6">
                      หลายร้อยเท่า!
                    </div>
                  </div>
                </div>

                <button className="group relative px-12 py-6 bg-gradient-to-r from-pink-500 via-red-500 to-orange-500 text-white font-bold text-xl rounded-full shadow-2xl hover:shadow-pink-500/40 transition-all duration-300 transform hover:scale-105 border-2 border-pink-400/50">
                  <span className="flex items-center space-x-3">
                    <SafeIcon icon={FiDollarSign} className="text-2xl" />
                    <span>🔥 สมัครทันที 9,995.- (รับโบนัสครบชุด)</span>
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-pink-600 via-red-600 to-orange-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  {/* Multiple Animated Rings */}
                  <div className="absolute inset-0 rounded-full border-2 border-white/20 animate-ping"></div>
                  <div className="absolute inset-0 rounded-full border-2 border-white/10 animate-ping delay-1000"></div>
                </button>
                
                <p className="text-pink-300 mt-6 font-semibold text-lg">
                  ⏳ รับจำนวนจำกัด เพื่อการดูแลทั่วถึง
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ValueSection;